import { render } from "./RegisterPage.vue?vue&type=template&id=45a43fc9"
import script from "./RegisterPage.vue?vue&type=script&lang=js"
export * from "./RegisterPage.vue?vue&type=script&lang=js"

import "./RegisterPage.vue?vue&type=style&index=0&id=45a43fc9&lang=css"
script.render = render

export default script